import {
  DOMAIN_COLOR,
  DOMAIN_COLOR_SOFT,
  DOMAIN_LABEL,
  type Domain,
} from "@/presentation/data/domains";

interface DomainPillProps {
  domain: Domain;
  size?: "xs" | "sm";
}

export function DomainPill({ domain, size = "xs" }: DomainPillProps) {
  const sizeClass = size === "sm" ? "text-[11px] px-2 py-0.5" : "text-[10px] px-1.5 py-0.5";
  return (
    <span
      data-slot="domain-pill"
      className={`font-data inline-flex items-center gap-1 rounded font-medium tracking-tight ${sizeClass}`}
      style={{
        background: DOMAIN_COLOR_SOFT[domain],
        color: DOMAIN_COLOR[domain],
      }}
    >
      <span
        className="size-1.5 rounded-full"
        style={{ background: DOMAIN_COLOR[domain] }}
        aria-hidden
      />
      {DOMAIN_LABEL[domain]}
    </span>
  );
}
